import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  Menu,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { useDebouncedState, useDisclosure, useHotkeys } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconDots, IconEdit, IconPlus, IconSearch } from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  repositoryMdm,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import { getValueById } from "../../../../_base/helper/FunctionHelper";
import { _localization } from "../../../../config/location";
import { MessageResponse } from "../../../../model/MessageResponse";
import { getProvinceSelectNew } from "../../../../service/getSelectApi";
import CreateConfigDeliveryXfast from "./CreateConfigDeliveryXfast";
import EditConfigDeliveryXfast from "./EditConfigDeliveryXfast";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

// Cấu hình giao vận Xfast chỉ lấy các bản ghi có loại vận chuyển là "Khác"
const TRANSPORT_TYPE_XFAST = "Khác";

const ConfigDeliveryXfast = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible] = useDisclosure(false);

  const location = useLocation();
  // Tab Xfast dùng chung route với tab "Cấu hình loại GV" nên phải tách key lưu tìm kiếm
  const searchStorageKey = `${String(location.pathname)}_xfast`;
  const _searchJson = sessionStorage.getItem(searchStorageKey)
    ? JSON.parse(sessionStorage.getItem(searchStorageKey) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search] = useState<any>({ attr16: TRANSPORT_TYPE_XFAST });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );

  const [dataProvince, setDataProvince] = useState<any[]>([]);
  const [dataCommune, setDataCommune] = useState<any[]>([]);
  const [listCommune, setListCommune] = useState<string[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "code",
        header: "Mã loại GV",
        Cell: ({ renderedCellValue }) => (
          <Badge color="green" variant="dot">
            {renderedCellValue}
          </Badge>
        ),
      },
      { accessorKey: "name", header: "Tên loại GV", size: 250 },
      {
        accessorKey: "att1",
        header: "Tỉnh/TP áp dụng",
        size: 325,
        Cell: ({ renderedCellValue }) => {
          const dataRender =
            renderedCellValue && String(renderedCellValue).length > 0
              ? String(renderedCellValue).trim().split(",")
              : null;

          if (!dataRender || dataRender.length === 0) return <></>;

          return dataRender.length <= 2 ? (
            <Flex gap={"xs"} wrap={"wrap"}>
              {dataRender.map((item, index) => (
                <Badge key={index} variant="outline">
                  {getValueById(String(item), dataProvince, "label")}
                </Badge>
              ))}
            </Flex>
          ) : (
            <Flex gap={"xs"} align={"center"}>
              {dataRender.slice(0, 2).map((item, index) => (
                <Badge key={index} variant="outline">
                  {getValueById(String(item), dataProvince, "label")}
                </Badge>
              ))}
              <Menu width={dataRender.length > 8 ? 650 : ""}>
                <Menu.Target>
                  <Tooltip label="Xem thêm">
                    <ActionIcon variant="outline" size={"xs"} radius={"xl"}>
                      <IconDots />
                    </ActionIcon>
                  </Tooltip>
                </Menu.Target>
                <Menu.Dropdown>
                  <Flex gap={"xs"} wrap={"wrap"}>
                    {dataRender.slice(2).map((item, index) => (
                      <Badge key={index} variant="outline">
                        {getValueById(String(item), dataProvince, "label")}
                      </Badge>
                    ))}
                  </Flex>
                </Menu.Dropdown>
              </Menu>
            </Flex>
          );
        },
      },
      {
        accessorKey: "att3",
        header: "Phường/xã nội thành",
        size: 350,
        Cell: ({ renderedCellValue }) => {
          const dataRender =
            renderedCellValue && String(renderedCellValue).length > 0
              ? String(renderedCellValue).trim().split(",")
              : null;

          if (!dataRender || dataRender.length === 0) return <></>;

          return dataRender.length <= 3 ? (
            <Flex gap={"xs"} wrap={"wrap"}>
              {dataRender.map((item, index) => (
                <Badge key={index} variant="outline" color="orange">
                  {getValueById(String(item), dataCommune, "label")}
                </Badge>
              ))}
            </Flex>
          ) : (
            <Flex gap={"xs"} align={"center"}>
              {dataRender.slice(0, 2).map((item, index) => (
                <Badge key={index} variant="outline" color="orange">
                  {getValueById(String(item), dataCommune, "label")}
                </Badge>
              ))}
              <Menu width={dataRender.length > 8 ? 650 : ""}>
                <Menu.Target>
                  <Tooltip label="Xem thêm">
                    <ActionIcon variant="outline" size={"xs"} radius={"xl"}>
                      <IconDots />
                    </ActionIcon>
                  </Tooltip>
                </Menu.Target>
                <Menu.Dropdown>
                  <Flex gap={"xs"} wrap={"wrap"}>
                    {dataRender.slice(2).map((item, index) => (
                      <Badge key={index} variant="outline" color="orange">
                        {getValueById(String(item), dataCommune, "label")}
                      </Badge>
                    ))}
                  </Flex>
                </Menu.Dropdown>
              </Menu>
            </Flex>
          );
        },
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnFilter: false,
        size: 80,
        Cell: ({ row }) => (
          <Flex justify={"start"} gap={"xs"}>
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                color="orange"
                onClick={() => modalsEditConfigDeliveryXfast(row.original)}
              >
                <IconEdit size={16} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [dataProvince, dataCommune],
  );

  const modalsCreateConfigDeliveryXfast = () => {
    modals.openConfirmModal({
      title: <Title order={5}>Tạo mới loại GV</Title>,
      size: "auto",
      children: <CreateConfigDeliveryXfast onSuccess={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const modalsEditConfigDeliveryXfast = (dataRow: any) => {
    modals.openConfirmModal({
      title: <Title order={5}>Chỉnh sửa loại GV</Title>,
      size: "auto",
      children: (
        <EditConfigDeliveryXfast data={dataRow} onSuccess={fetchData} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/WebsiteDelivery/get-list?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryPos.get<MessageResponse<any>>(url);

      if (res && res.success) {
        // Lọc lại phía client phòng khi API chưa hỗ trợ filter theo attr16
        const result = (res.data ?? []).filter(
          (i: any) => i.attr16 === TRANSPORT_TYPE_XFAST,
        );
        const dataListCommune = result.map((i: any) => i.att3).join(",");
        setListCommune([
          ...new Set(
            dataListCommune
              .split(",")
              .filter((i: any) => i && String(i).length > 0),
          ),
        ] as string[]);
        setData(result);
        setRowCount(res.totalCount);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        searchStorageKey,
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        }),
      );
    }
  };

  const fetchDataProvince = async () => {
    const res = await getProvinceSelectNew();

    if (res) {
      setDataProvince(
        res
          ?.filter((item) => item.id && item.name)
          ?.map((item) => ({
            value: String(item.id),
            label: String(item.name),
          })),
      );
    }
  };

  const fetchDataCommune = async () => {
    const url =
      listCommune && listCommune.length > 0
        ? listCommune.map((i) => `Ids=${i}`).join("&")
        : "";
    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmCommuneMoi/get-select?${url}`,
    );

    if (res && res.success) {
      const result = res.data
        ?.filter((i: any) => i.text && i.value)
        ?.map((i: any) => ({
          label: String(i.text),
          value: String(i.value),
        }));
      setDataCommune(result);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    fetchDataProvince();
  }, []);

  useEffect(() => {
    if (listCommune && listCommune?.length > 0) {
      fetchDataCommune();
    }
  }, [listCommune]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningConfigDeliveryXfast",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select", "mrt-row-numbers", "code"],
          right: ["action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningConfigDeliveryXfast",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (250 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: () => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: () => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <Grid mt={10} w={"90%"}>
            <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
              <TextInput
                placeholder="Nhập từ khóa tìm kiếm"
                defaultValue={keySearch}
                onChange={(e) => setKeySearch(e.currentTarget.value)}
                leftSection={<IconSearch color="#15aabf" />}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    fetchData();
                  }
                }}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
              <Button
                onClick={() => fetchData()}
                leftSection={<IconSearch size={14} />}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
          <Button
            leftSection={<IconPlus size={16} />}
            color="green"
            onClick={() => modalsCreateConfigDeliveryXfast()}
          >
            Thêm mới
          </Button>
        </Flex>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default ConfigDeliveryXfast;
